module.exports = __webpack_public_path__ + "static/media/u23a-c_5.34634bcf.mp3";